<template>
  <v-dialog v-model="dialog" hide-overlay persistent width="300">
    <v-card color="primary" dark class="py-4">
      <v-card-text class="text-center">
        <div>Prosess... mendownload assets aplikasi untuk pertama kali..</div>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0 mt-3"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: true,
    };
  },
};
</script>

<style>
</style>